import { channels } from '@/mocks/homeData';
import SectionHead from './SectionHead';

export default function Channels() {
  return (
    <section id="channels" className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14">
      <SectionHead
        anchorId="channels"
        kicker="Sections · 栏目分区"
        title="按瓜田找货"
        desc="不同题材分门别类，想看哪块直接钻进对应瓜田，不必大海捞针。"
        href="#channels"
        accent="secondary"
      />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
        {channels.map((c, i) => (
          <a
            key={i}
            href="#channels"
            className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-accent-300 hover:bg-accent-50"
          >
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-900 transition-colors group-hover:bg-accent-500 group-hover:text-background-50">
              <i className={`${c.icon} text-lg`}></i>
            </span>
            <div className="min-w-0">
              <h3 className="text-sm font-bold text-foreground-950">{c.name}</h3>
              <p className="truncate text-xs text-foreground-500">{c.desc}</p>
            </div>
            <i className="ri-arrow-right-s-line ml-auto text-foreground-300 transition-colors group-hover:text-accent-600"></i>
          </a>
        ))}
      </div>
    </section>
  );
}